class DropdownMenuSearch {
    constructor(formID) {
        this.initDropdownSearch(formID)
    }
    initDropdownSearch(formID){
        let form = document.getElementById(formID);
        if(form){
            let searchInputs = form.querySelectorAll('[data-kt-menu-filter="search"]');
            searchInputs.forEach(function (input) {
                let showNoResults = true;
                let parentMenu = input.closest('.menu.menu-sub.menu-sub-dropdown');
                input.addEventListener('input', function () {
                    showNoResults = true;
                    let filterValue = input.value.toLowerCase();
                    if (parentMenu) {
                        parentMenu.querySelectorAll('.menu-link[type]').forEach(function (element) {
                            if(filterValue){
                                element.classList.add('d-none');
                            } else {
                                element.classList.remove('d-none');
                            }
                        });

                        let elementsToShow = parentMenu.querySelectorAll('.menu-link[type*="' + filterValue + '"]');
                        elementsToShow.forEach(function (element) {
                            element.classList.remove('d-none');
                            showNoResults = false;
                        });

                        if(showNoResults && filterValue){
                            parentMenu.querySelector('[data-kt-menu-filter="no-results"]').classList.remove('d-none');
                        } else {
                            parentMenu.querySelector('[data-kt-menu-filter="no-results"]').classList.add('d-none');
                        }
                    }
                });
            });
        }
    }
}
window.DropdownMenuSearch = DropdownMenuSearch;